var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTracebilityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4119_24096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 15.4648V16.793C14.5312 18.5189 13.1321 19.918 11.4062 19.918H3.90625C2.18035 19.918 0.78125 18.5189 0.78125 16.793V4.60547C0.78125 2.87957 2.18035 1.48047 3.90625 1.48047H11.4062C13.1321 1.48047 14.5312 2.87957 14.5312 4.60547V7.80861M3.90625 6.01172L5.07812 7.18359L7.03125 5.23047M3.90625 10.6992L5.07812 11.8711L7.03125 9.91797M3.90625 15.3867L5.07812 16.5586L7.03125 14.6055M16.1483 14.7203L19.2187 18.668M14.5312 7.80861C14.2788 7.75737 14.0176 7.73047 13.75 7.73047C11.5926 7.73047 9.84375 9.47936 9.84375 11.6367C9.84375 13.7941 11.5926 15.543 13.75 15.543C15.9074 15.543 17.6562 13.7941 17.6562 11.6367C17.6562 9.74691 16.3142 8.17054 14.5312 7.80861Z",
    stroke: "#706F7B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4119_24096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.699219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracebilityIcon);
export default __webpack_public_path__ + "static/media/tracebilityIcon.de280f443cfe9c175984c0471fa2241c.svg";
export { ForwardRef as ReactComponent };